<template>
  <swiper
    class='stashboard-carousel'
    slides-per-view="auto"
    :pagination="swiperPagination"
    :autoplay="autoplayOptions"
    :autoHeight="true"
    @swiper="onSwiper"
    @slideChange="slideChange"
    @touchStart="touchStart"
  >
    <swiper-slide :key="index"
                  class="text-center"
                  v-for="(slide, index) of slides">
      <slot name="swiper-slide-content" :slide="slide" :index="index" />
    </swiper-slide>
    <div class="stashboard-swiper-pagination" v-if="slides.length > 1"></div>
  </swiper>
</template>

<script>

import { Pagination, Autoplay } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";

SwiperCore.use([Pagination, Autoplay])

export default {
  name: 'Carousel',

  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    slides: Array
  },
  methods: {
    onSwiper(swiper) {
      this.swiper = swiper

      if (this.isCurrentSlideVideo()) {
        this.playVideo(swiper)
        this.setVideoHeight(swiper)
      } else {
      }
    },
    slideChange(swiper) {
      if (this.isCurrentSlideVideo()) this.playVideo(swiper)
      if (this.isPrevSlideVideo()) this.$emit('pauseVideo', swiper, this.slides[this.swiper.previousIndex])
    },
    videoEnded() {
      this.swiper.slideNext()
      this.swiper.autoplay.start()
    },
    playVideo(swiper) {
      swiper.autoplay.stop()
      this.$emit('playVideo', swiper, this.slides[this.swiper.snapIndex]);
    },
    setVideoHeight(swiper) {
      this.$emit('setVideoHeight', swiper, this.slides[this.swiper.snapIndex]);
    },
    isCurrentSlideVideo() {
      return this.slides[this.swiper.snapIndex].isVideo
    },
    isPrevSlideVideo() {
      return this.slides[this.swiper.previousIndex].isVideo
    },
    touchStart() {
      this.$emit('onUserInteraction')
    },
  },
  computed: {
    swiperPagination() {
      return {
        el: '.stashboard-swiper-pagination',
        clickable: true
      }
    },
    autoplayOptions() {
      return {
        delay: 6000
      }
    },
  }
};
</script>

<style lang="scss" scoped>
  .stashboard-swiper-pagination::v-deep {
    background-color: rgba(black, .5);
    padding: 7px 12px;
    border-radius: 12px;
    text-align: center;
    transition: opacity .3s;
    transform: translateZ(0);
    z-index: 10;
    margin-left: auto;
    margin-right: auto;
    width: fit-content !important;
    position: absolute;
    left: 0;
    right: 0;

    .swiper-pagination-bullet {
      background-color: #A2A2A2;
      width: 10px !important;
      height: 10px !important;

      &-active {
        background-color: white;
      }
    }
  }
</style>
